module.exports = __webpack_public_path__ + "media/images/favicons/favicon-44ad2e8e492472591a84b09e96a47c62.ico";